import { useQueryClient } from '@tanstack/react-query';
import {
  Button,
  Div,
  H3,
  IncidentMessage,
  ModalIconStyle,
  P,
  PropsModal,
  SuccessToast,
  TrashIcon,
  deleteIncidentMessage,
  queryKeys,
  reportError,
} from '@vgrubs/components';
import { useState } from 'react';

export const DeleteIncidentMessageModal = ({
  incidentMessage,
  closeModal,
}: PropsModal & {
  incidentMessage: IncidentMessage;
}) => {
  const [loading, setLoading] = useState(false);
  const queryClient = useQueryClient();
  async function handleDelete() {
    try {
      setLoading(true);
      const { data } = await deleteIncidentMessage(incidentMessage.id);
      SuccessToast(data.message);
      setLoading(false);
      closeModal?.();
      queryClient.invalidateQueries({ queryKey: queryKeys.incidentMessages.all });
    } catch (error) {
      reportError(error);
      setLoading(false);
    }
  }

  return (
    <Div $flex $column $center>
      <Div $flex $justifyCenter>
        <ModalIconStyle>
          <TrashIcon />
        </ModalIconStyle>
      </Div>
      <H3 $mb="8">Delete Incident Message?</H3>
      <P $mb="24">Are you sure you want to delete this incident message?</P>

      <Div $flex $gap="16px" $justifyCenter $width="100%">
        <Button
          $selected
          $w="100%"
          onClick={() => handleDelete()}
          $loading={loading}
        >
          Confirm
        </Button>
        <Button $selected $gray $w="100%" onClick={() => closeModal?.()}>
          Cancel
        </Button>
      </Div>
    </Div>
  );
};
